import React, { useState, useRef } from 'react';
import './MemberEmails.css';
import CurvedHeader from './CurvedHeader';
import OptimizedImage from './OptimizedImage';

import MonthlyAccountUpdatesImg from 'url:../../assets-optimized/redesign/solutions/marriott-digital/MonthlyAccountUpdates.png';
import MonthlyAccountUpdatesImgavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/MonthlyAccountUpdates.avif';
import MonthlyAccountUpdatesImgwebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/MonthlyAccountUpdates.webp';

import DemandGenImg from 'url:../../assets-optimized/redesign/solutions/marriott-digital/DemandGen.png';
import DemandGenImgavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/DemandGen.avif';
import DemandGenImgwebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/DemandGen.webp';

import TravelerEmailImg from 'url:../../assets-optimized/redesign/solutions/marriott-digital/TravelerEmail.png';
import TravelerEmailImgavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/TravelerEmail.avif';
import TravelerEmailImgwebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/TravelerEmail.webp';

const TABS = [
  'Monthly account updates email',
  'Escapes and traveler emails',
  'Property Highlight Emails',
];

const TAB_IMAGES = {
  'Monthly account updates email': {
    avif: MonthlyAccountUpdatesImgavif,
    webp: MonthlyAccountUpdatesImgwebp,
    fallback: MonthlyAccountUpdatesImg,
  },
  'Escapes and traveler emails': {
    avif: TravelerEmailImgavif,
    webp: TravelerEmailImgwebp,
    fallback: TravelerEmailImg,
  },
  'Property Highlight Emails': {
    avif: DemandGenImgavif,
    webp: DemandGenImgwebp,
    fallback: DemandGenImg,
  },
};

export default function MemberEmails() {
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const contentRef = useRef(null);

  const scrollToContent = () => {
    contentRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className='member-emails'>
      <CurvedHeader
        title='MEMBER EMAILS'
        pills={[
          {
            titleBold: '4+ EMAIL CATEGORIES',
            textLight: 'Including Traveler and Account',
            icon: (
              <svg
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M23 6l-9.5 9.5-5-5L1 18' />
                <path d='M17 6h6v6' />
              </svg>
            ),
          },
        ]}
        backgroundColor='#2cb1e8'
        titleColor='#1a1a1a'
        pillBackgroundColor='white'
        pillTextColor='#1a1a1a'
        pillIconBackgroundColor='#2cb1e8'
        pillIconColor='white'
        arrowColor='#1a1a1a'
        onArrowClick={scrollToContent}
      />

      <div className='member-emails__content-wrapper' ref={contentRef}>
        <div className='member-emails__content'>
          <div className='member-emails__tabs-container'>
            <div className='member-emails__tabs'>
              {TABS.map((tab) => (
                <div key={tab} className='member-emails__tab-wrapper'>
                  <button
                    className={`member-emails__tab ${activeTab === tab ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab)}
                    onMouseEnter={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                  {activeTab === tab && (
                    <div className='member-emails__tab-arrow'>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      >
                        <path d='M5 12h14' />
                        <path d='M12 5l7 7-7 7' />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className='member-emails__image-container'>
            <OptimizedImage
              avif={TAB_IMAGES[activeTab].avif}
              webp={TAB_IMAGES[activeTab].webp}
              fallback={TAB_IMAGES[activeTab].fallback}
              alt='Email Mockup'
            />
          </div>

          <div className='member-emails__details'>
            <h3 className='member-emails__details-title'>
              RECONNECT WITH TRAVELERS ON TO THE NEXT
            </h3>
            <p className='member-emails__details-text'>
              Integrate your message into a meaningful touchpoint that guests look forward to
              engaging with.
            </p>
            <div className='member-emails__stats-card'>
              <h4>+5.0pp avg. lift</h4>
              <p>in brand awareness across measured campaigns</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
